export default __webpack_public_path__ + "static/media/coresanscr75it-webfont.fb9c3293.woff2";